import React from "react";
import {
  Button,
  Box,
  Flex,
  Stack,
  Text,
  StatNumber,

} from "@chakra-ui/core";
import {
  FaLink,
  FaCaretUp,
  FaBalanceScale,
} from "react-icons/fa";
import { GoGraph } from "react-icons/go";
import { MdSettings, MdAccountBalanceWallet } from "react-icons/md";
import { FaExternalLinkAlt } from "react-icons/fa"

/** The section right below the dashboard header
 * This section contain high level info and actions such as 
 * Week performance and connection to Stripe account
 */

const DasboardLeadingSectionMockup = () => {
  return (
    <>
      <Box width="100%" py="15px" bg="primary.600" p={0}>
        <Flex align="center" justify="center" w="100%">
          <Box maxWidth="1280px" w="100%" h="100%">
            <Flex
              flexWrap="wrap"
              size="100%"
              align="center"
              justifyContent="space-between"
            >
              <Stack alignItems="flex-start" minW="300px" mx="22px">
                <Stack spacing={0}>
                  <Stack alignItems="center" isInline>
                    <Text color="primary.100" ontWeight="bold" fontSize="2xl">
                      Pizza Yolo Inc <br />
                    </Text>
                    <Box color="primary.100" size="20px" as={MdSettings} />
                  </Stack>
                  <Stack alignItems="center" isInline color="success.600" fontSize="12px">
                  <Text fontSize="xs" >
                    View your Stripe account 
                  </Text>
                  <Box as={FaExternalLinkAlt} />
                  </Stack>
                </Stack>

                <Stack
                  my="16px"
                  flexWrap="wrap"
                  color="primary.300"
                  spacing={8}
                  isInline
                  w="100%"
                >
                  <Box>
                    <Stack spacing={1} alignItems="flex-end" isInline>
                      <Box
                        my="3px"
                        as={GoGraph}
                        color="primary.400"
                        size="12px"
                      />
                      <Text color="primary.100" fontSize="xs">
                        This week
                      </Text>
                      <Box as={FaCaretUp} color="success.500" />
                      <Text fontSize="sm">23.36%</Text>
                    </Stack>
                    <StatNumber>345,670 €</StatNumber>
                  </Box>
                  <Box>
                    <Stack spacing={1} alignItems="flex-end" isInline>
                      <Box
                        my="3px"
                        as={FaBalanceScale}
                        color="primary.400"
                        size="12px"
                      />
                      <Text color="primary.100" fontSize="xs">
                        Your balance
                      </Text>
                      <Text fontSize="sm">45 € available</Text>
                    </Stack>
                    <StatNumber>240 €</StatNumber>
                  </Box>
                </Stack>
              </Stack>

              <Stack m="16px" isInline spacing={2} align="center">
                <Button
                  size="sm"
                  cursor="default"
                  bg="primary.500"
                  _hover={{
                    bg: "none",
                  }}
                  color="primary.100"
                  leftIcon={MdAccountBalanceWallet}
                >
                  Payout now
                </Button>
                <Button
                  size="sm"
                  cursor="default"
                  bg="success.600"
                  _hover={{
                    bg: "none",
                  }}
                  color="primary.100"
                  leftIcon={FaLink}
                >
                  New Payment Link
                </Button>
              </Stack>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default DasboardLeadingSectionMockup;